;(function($){

    function Prospectus_contacts() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        if ($("#has_a_contract").length > 0) {
            _.init($("#has_a_contract").val());
        }        

        $("#has_a_contract").on("change", function(e){

            _.init($(this).val());
        });  
    } 

    Prospectus_contacts.prototype.init = function(value) {

        if(value == 1) {
            $("#has_a_contract_company").attr('disabled', false);
            $("#has_a_contract_date_init").attr('disabled', false);
            $("#has_a_contract_date_end").attr('disabled', false);
            $("#has_a_contract_value").attr('disabled', false);
        }else {
            $("#has_a_contract_company").attr('disabled', true).val('');
            $("#has_a_contract_date_init").attr('disabled', true).val('');
            $("#has_a_contract_date_end").attr('disabled', true).val('');
            $("#has_a_contract_value").attr('disabled', true).val('');
        }
    }

   	new Prospectus_contacts();

}(jQuery));
 
 
 
 
